import React, { useState, useRef } from "react";
import * as Yup from "yup";
import { Form } from "@unform/web";
import { Box } from "@mui/material";
import { FormHandles } from "@unform/core";
import { ModalBase } from "../../Producer_bkp/ModalBase";
import { RichTextInput } from "../../..";
import { Button } from "../../../elements";
import { useCreateFromModal } from "../../../../hooks/useCreateFromModal";
import ArticlesDebatesService from "../../../../services/articlesDebatesService.service";

export interface Props {
    articleId: number;
    debateData?: any;
    icon?: React.FC<{ size?: string; onClick?: () => any }>;
    successCallback?: () => void;
}

const CreateDebateWrapper: React.FC<Props> = ({ articleId, debateData, icon: Icon, successCallback, ...props }: Props) => {
    const [open, setOpen] = useState(false);
    const isUpdate = !!debateData;
    const formRef = useRef<FormHandles>(null);
    const schema = Yup.object().shape({
        descricao: Yup.string().required("Este campo é obrigatório."),
    });

    const handleSuccess = (data: any) => {
        setOpen(false);
        if (successCallback) {
            successCallback();
        }
    };
    const { handleSubmit, loading } = useCreateFromModal({
        formRef,
        schema,
        isUpdate,
        item: debateData,
        service: new ArticlesDebatesService(articleId),
        successMessage: `Debate ${isUpdate ? "Alterado" : "Criado!"}`,
        handleSuccess,
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const submitForm = () => {
        formRef?.current?.submitForm();
    };
    return (
        <>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
                {Icon === undefined && (
                    <Button variant="add" onClick={handleClickOpen}>
                        Novo Comentário
                    </Button>
                )}
                {Icon && <Icon size="20px" onClick={handleClickOpen} />}
            </Box>
            <ModalBase
                loading={loading}
                open={open}
                title={isUpdate ? "Editar Comentário" : "Criar Novo Comentário"}
                handleClose={handleClose}
                saveAction={submitForm}>
                <Form
                    ref={formRef}
                    onSubmit={handleSubmit}
                    initialData={{
                        descricao: debateData?.description,
                    }}
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}>
                    <Box display="grid" gridTemplateColumns="1fr" gridTemplateRows="3fr" rowGap="20px" columnGap="20px">
                        <RichTextInput name="descricao" label="Descrição" />
                    </Box>
                </Form>
            </ModalBase>
        </>
    );
};

export { CreateDebateWrapper as CreateArticleDebate };
